import React, { useReducer, useRef } from 'react';

import { MANTY_AUTH } from 'business/constants';
import { EnrichedUserT } from 'business/definitions';
import { findSSOAuthAuth } from 'helpers/helpers';
import { useSelector } from 'store/hooks';

import {
    UserCreationFormContext,
    UserCreationFormDispatchContext,
} from './CreateUserFormContext';
import {
    INITIAL_USER_FORM,
    userCreationFormReducer,
} from './CreateUserFormReducer';
import { UserCreationFormAction } from './types';

const CreateUserFormProvider = ({
    children,
    userToUpdate,
}: {
    userToUpdate?: EnrichedUserT;
    children: React.ReactNode;
}) => {
    const hasDispatchBeenCalled = useRef(false);
    const clientAuthMethods = useSelector(
        (state) => state.vision.client.authMethods,
    );
    const [userCreationFormState, dispatch] = useReducer(
        userCreationFormReducer,
        userToUpdate ?? {
            ...INITIAL_USER_FORM,
            authMethods: [findSSOAuthAuth(clientAuthMethods) || MANTY_AUTH],
        },
    );

    const dispatchUserCreationForm = (action: UserCreationFormAction) => {
        hasDispatchBeenCalled.current = true;
        dispatch(action);
    };
    return (
        <UserCreationFormContext.Provider value={userCreationFormState}>
            <UserCreationFormDispatchContext.Provider
                value={{ dispatchUserCreationForm, hasDispatchBeenCalled }}
            >
                {children}
            </UserCreationFormDispatchContext.Provider>
        </UserCreationFormContext.Provider>
    );
};

export default CreateUserFormProvider;
